import { useEntityAPI } from '../../../redux/entity-api.hook';
import { supplierCategoriesAPI } from '../redux/supplier-categories.slice';

export function useSupplierCategories() {
  return useEntityAPI(supplierCategoriesAPI);
}
